import { render, staticRenderFns } from "./tesk.vue?vue&type=template&id=57152706&scoped=true"
import script from "./tesk.vue?vue&type=script&lang=js"
export * from "./tesk.vue?vue&type=script&lang=js"
import style0 from "./tesk.vue?vue&type=style&index=0&id=57152706&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57152706",
  null
  
)

export default component.exports